import {Box, Skeleton} from '@chakra-ui/react';
import {HeaderWrapper} from 'components/layouts';
import {colors} from 'components/providers';
import {FC} from 'react';

const skeletonArray = new Array(10).fill(1);

export const CategorySubheaderSkeleton: FC = () => {
  return (
    <Box borderTop="1px" w="100%" borderColor={colors.borderGray}>
      <HeaderWrapper overflow="hidden" boxShadow="header" as="nav" innerbox={{p: 0}}>
        {skeletonArray.map((_, index) => {
          return (
            <Skeleton key={index} w={['80px', '140px']} h={['30px', '45px']} borderRadius="16px" px="12px" ml="15px" />
          );
        })}
      </HeaderWrapper>
    </Box>
  );
};
